import React, { useState, useEffect, useContext } from 'react';
import { Form, Button, Row, Col } from 'react-bootstrap';
import { MdArrowBack } from "react-icons/md";
import { FiMinusCircle } from "react-icons/fi";
import { useNavigate } from 'react-router-dom';
import * as apicall from '../../components/Apicall';
import { getRole } from '../../components/Apicall';
import { toast } from 'react-toastify';
import { Formik } from 'formik';
import * as Yup from 'yup';
import UserContext from '../../components/context/UserContext'


const DoctorAvailability = ({ showBackButton = true, showPadding = true, doctorId, ...props }) => {

  // Prepare initial empty values
  const emptyInitialValues = {
    appointmentDuration: '15',
    numberOfSlots: '1',
    schedule: [
      {
        day: 1,
        checked: true,
        workingHours: [{ startTime: '', endTime: '', fee: '' }],
        breakTimings: [{ breakStartTime: '', breakEndTime: '' }]
      },
      {
        day: 2,
        checked: true,
        workingHours: [{ startTime: '', endTime: '', fee: '' }],
        breakTimings: [{ breakStartTime: '', breakEndTime: '' }]
      },
      {
        day: 3,
        checked: true,
        workingHours: [{ startTime: '', endTime: '', fee: '' }],
        breakTimings: [{ breakStartTime: '', breakEndTime: '' }]
      },
      {
        day: 4,
        checked: true,
        workingHours: [{ startTime: '', endTime: '', fee: '' }],
        breakTimings: [{ breakStartTime: '', breakEndTime: '' }]
      },
      {
        day: 5,
        checked: true,
        workingHours: [{ startTime: '', endTime: '', fee: '' }],
        breakTimings: [{ breakStartTime: '', breakEndTime: '' }]
      },
      {
        day: 6,
        checked: false,
        workingHours: [{ startTime: '', endTime: '', fee: '' }],
        breakTimings: [{ breakStartTime: '', breakEndTime: '' }]
      },
      {
        day: 7,
        checked: false,
        workingHours: [{ startTime: '', endTime: '', fee: '' }],
        breakTimings: [{ breakStartTime: '', breakEndTime: '' }]
      },
    ]
  };
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [doctorDetails, setDoctorDetails] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [feeRange, setFeeRange] = useState({
    fee_from: '',
    fee_to: '',
    working_hours_start: '',
    working_hours_end: ''
  });
  const { vendor, refreshVendorData } = useContext(UserContext);
  const [initialData, setInitialData] = useState(emptyInitialValues);

  // Function to handle navigation based on URL pattern
  const handleNavigation = () => {
    if (userRole === '3') {
      const currentPath = window.location.pathname;
      if (currentPath.includes('/doctors/add/availability')) {
        navigate('/doctors/add');
      } else if (currentPath.includes('/doctors/profile/')) {
        navigate('/doctors');
      }
    } else {
      navigate('/users');
    }
  };

  // Add cleanup function for session storage
  useEffect(() => {
    // Cleanup function to run when component unmounts
    return () => {
      // Only clear session storage if navigating away from the doctor flow
      const currentPath = window.location.pathname;
      if (!currentPath.includes('/doctors/add') && !currentPath.includes('/doctors/profile/')) {
        sessionStorage.removeItem('doctorDetails');
      }
    };
  }, []);

  useEffect(() => {
    const role = getRole();
    setUserRole(role);

    refreshVendorData();
  }, []);

  useEffect(() => {
    if (vendor) {
      const newFeeRange = {
        fee_from: vendor.fee_from || '',
        fee_to: vendor.fee_to || '',
        working_hours_start: vendor.working_hours_start || '',
        working_hours_end: vendor.working_hours_end || ''
      };
      setFeeRange(newFeeRange);
    } else {
      setFeeRange({ fee_from: '', fee_to: '' });
    }
  }, [vendor]);

  useEffect(() => {
    const handleStorageChange = () => {
      const newVendorId = localStorage.getItem('vendorId');
      if (newVendorId !== vendor?.user_id) {
        setFeeRange({ fee_from: '', fee_to: '' });
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [vendor]);

  useEffect(() => {
    if (vendor && feeRange.working_hours_start && feeRange.working_hours_end) {
      setInitialData(prev => {
        const currentData = prev || emptyInitialValues;
        return {
          ...currentData,
          schedule: currentData.schedule.map(day => {
            // Only update Monday-Friday (days 1-5) that are checked
            if (day.day <= 5 && day.checked) {
              return {
                ...day,
                workingHours: day.workingHours.length === 0 ||
                  (!day.workingHours[0].startTime && !day.workingHours[0].endTime)
                  ? [{
                    startTime: feeRange.working_hours_start.substring(0, 5),
                    endTime: feeRange.working_hours_end.substring(0, 5),
                    fee: day.workingHours[0]?.fee || ''
                  }]
                  : day.workingHours
              };
            }
            return day;
          })
        };
      });
    }
  }, [vendor, feeRange]);

  // Empty values for edit mode
  const emptyEditValues = {
    appointmentDuration: '',
    numberOfSlots: '',
    schedule: [
      {
        day: 1,
        checked: false,
        workingHours: [{ startTime: '', endTime: '', fee: '' }],
        breakTimings: [{ breakStartTime: '', breakEndTime: '' }]
      },
      {
        day: 2,
        checked: false,
        workingHours: [{ startTime: '', endTime: '', fee: '' }],
        breakTimings: [{ breakStartTime: '', breakEndTime: '' }]
      },
      {
        day: 3,
        checked: false,
        workingHours: [{ startTime: '', endTime: '', fee: '' }],
        breakTimings: [{ breakStartTime: '', breakEndTime: '' }]
      },
      {
        day: 4,
        checked: false,
        workingHours: [{ startTime: '', endTime: '', fee: '' }],
        breakTimings: [{ breakStartTime: '', breakEndTime: '' }]
      },
      {
        day: 5,
        checked: false,
        workingHours: [{ startTime: '', endTime: '', fee: '' }],
        breakTimings: [{ breakStartTime: '', breakEndTime: '' }]
      },
      {
        day: 6,
        checked: false,
        workingHours: [{ startTime: '', endTime: '', fee: '' }],
        breakTimings: [{ breakStartTime: '', breakEndTime: '' }]
      },
      {
        day: 7,
        checked: false,
        workingHours: [{ startTime: '', endTime: '', fee: '' }],
        breakTimings: [{ breakStartTime: '', breakEndTime: '' }]
      },
    ]
  };

  useEffect(() => {
    const fetchDoctorAvailability = async () => {
      try {
        if (doctorId) {
          const response = await apicall.get(`get_availability/${doctorId}`);
          if (response && response.data) {
            // Transform API data to match our form structure
            const transformedData = {
              appointmentDuration: response.data.appointment_duration?.toString() || '',
              numberOfSlots: response.data.no_of_slots?.toString() || '',
              schedule: emptyInitialValues.schedule.map(day => {
                const shifts = (response.data.shifts || []).filter(shift => shift.day === day.day);
                const isChecked = shifts.length > 0; // Determine checked status from API

                if (!isChecked) {
                  return {
                    ...day,
                    checked: false,
                    workingHours: [{ startTime: '', endTime: '', fee: '' }],
                    breakTimings: [{ breakStartTime: '', breakEndTime: '' }]
                  };
                }

                // Group shifts by working hours (start_time and end_time)
                const workingHoursMap = new Map();
                const breakTimingsMap = new Map();

                shifts.forEach(shift => {
                  const workingKey = `${shift.start_time}-${shift.end_time}`;

                  // Handle working hours
                  if (shift.start_time && shift.start_time !== '00:00:00') {
                    if (!workingHoursMap.has(workingKey)) {
                      workingHoursMap.set(workingKey, {
                        startTime: shift.start_time?.substring(0, 5) || '',
                        endTime: shift.end_time?.substring(0, 5) || '',
                        fee: shift.fee?.toString() || ''
                      });
                    }
                  }

                  // Handle break timings
                  if (shift.break_start_time && shift.break_start_time !== '00:00:00') {
                    if (!breakTimingsMap.has(workingKey)) {
                      breakTimingsMap.set(workingKey, []);
                    }
                    breakTimingsMap.get(workingKey).push({
                      breakStartTime: shift.break_start_time.substring(0, 5),
                      breakEndTime: shift.break_end_time && shift.break_end_time !== '00:00:00'
                        ? shift.break_end_time.substring(0, 5)
                        : ''
                    });
                  }
                });

                // Convert maps to arrays
                const workingHours = Array.from(workingHoursMap.values());
                const breakTimings = Array.from(breakTimingsMap.values()).flat();

                return {
                  ...day,
                  checked: isChecked,
                  workingHours: workingHours.length > 0 ? workingHours : [{ startTime: '', endTime: '', fee: '' }],
                  breakTimings: breakTimings.length > 0 ? breakTimings : [{ breakStartTime: '', breakEndTime: '' }]
                };
              })
            };
            setInitialData(transformedData);
            setDoctorDetails(response.data);
          } else {
            setInitialData(emptyEditValues);
          }
        } else {
          // Handle case when adding new doctor
          const storedDetails = sessionStorage.getItem('doctorDetails');
          if (storedDetails) {
            try {
              const parsedDetails = JSON.parse(storedDetails);
              setDoctorDetails(parsedDetails);
              setInitialData(emptyInitialValues);
            } catch (error) {
              console.error('Error parsing doctor details:', error);
              navigate('/doctors/add');
            }
          } else {
            navigate('/doctors/add');
          }
        }
      } catch (error) {
        console.error('Error fetching doctor availability:', error);
        if (doctorId) {
          setInitialData(emptyEditValues);
        } else {
          setInitialData(emptyInitialValues);
        }
      }
    };

    fetchDoctorAvailability();
  }, [navigate, doctorId]);

  const validationSchema = Yup.object().shape({
    appointmentDuration: Yup.string().required('Appointment duration is required'),
    numberOfSlots: Yup.string().required('Number of slots is required'),
    schedule: Yup.array().of(
      Yup.object().shape({
        checked: Yup.boolean(),
        workingHours: Yup.array().of(
          Yup.object().shape({
            startTime: Yup.string()
              .test('required-if-checked', 'Start time is required when day is selected', function (value) {
                return !this.options.from[1].value.checked || (this.options.from[1].value.checked && value);
              })
              .test('start-time-within-range', 'Start time must be within vendors working hours range', function (value) {
                if (!value || !this.options.from[1].value.checked) return true;
                const apiStartTime = feeRange.working_hours_start?.substring(0, 5);
                const apiEndTime = feeRange.working_hours_end?.substring(0, 5);
                if (!apiStartTime || !apiEndTime) return true;
                return value >= apiStartTime && value <= apiEndTime;
              })
              .test('start-time-after-previous-end', 'Start time must be after previous row end time', function (value) {
                if (!value || !this.options.from[1].value.checked) return true;
                const workingHours = this.from[1].value.workingHours;
                const currentIndex = workingHours.findIndex(
                  wh => wh.startTime === value
                );

                if (currentIndex === 0) return true;
                const previousEndTime = workingHours[currentIndex - 1].endTime;
                if (!previousEndTime) return true;
                return value > previousEndTime;
              }),
            endTime: Yup.string()
              .test('required-if-checked', 'End time is required when day is selected', function (value) {
                return !this.options.from[1].value.checked || (this.options.from[1].value.checked && value);
              })
              .test('end-time-within-range', 'End time must be within vendors working hours range', function (value) {
                if (!value || !this.options.from[1].value.checked) return true;
                const apiStartTime = feeRange.working_hours_start?.substring(0, 5);
                const apiEndTime = feeRange.working_hours_end?.substring(0, 5);
                if (!apiStartTime || !apiEndTime) return true;
                return value >= apiStartTime && value <= apiEndTime;
              })
              .test('end-time-after-start', 'End time must be after start time', function (value) {
                if (!this.parent.startTime || !value) return true;
                return value > this.parent.startTime;
              }),
            fee: Yup.string()
              .test('required-if-checked', 'Fee is required when day is selected', function (value) {
                return !this.options.from[1].value.checked || (this.options.from[1].value.checked && value);
              })
              .test('fee-range', 'Fee must be within the specified range', function (value) {
                if (!value || !this.options.from[1].value.checked) return true;
                const fee = parseInt(value);
                const feeFrom = parseInt(feeRange.fee_from);
                const feeTo = parseInt(feeRange.fee_to);
                return fee >= feeFrom && fee <= feeTo;
              })
          })
        ),
        breakTimings: Yup.array().of(
          Yup.object().shape({
            breakStartTime: Yup.string()
              .test('break-start-validation', 'Break start time must be within valid working hours', function (value) {
                if (!value || !this.options.from[1].value.checked) return true;
                const day = this.options.from[1].value;
                const parent = this.options.context; // Access parent form values
                // 1. First try to validate against this row's working hours
                const currentRowWorkingHours = day.workingHours.filter(wh =>
                  wh.startTime && wh.endTime && wh.startTime !== '00:00' && wh.endTime !== '00:00'
                );
                // Check against current row's working hours if any exist
                if (currentRowWorkingHours.length > 0) {
                  return currentRowWorkingHours.some(wh =>
                    value >= wh.startTime && value <= wh.endTime
                  );
                }
                // 2. If no valid working hours in current row, look at first working hours in schedule
                if (parent && parent.schedule) {
                  const firstValidWorkingHours = parent.schedule
                    .flatMap(day => day.workingHours)
                    .find(wh => wh.startTime && wh.endTime && wh.startTime !== '00:00' && wh.endTime !== '00:00');
                  if (firstValidWorkingHours) {
                    return value >= firstValidWorkingHours.startTime && value <= firstValidWorkingHours.endTime;
                  }
                }
                // 3. If no reference working hours found at all, skip validation
                return true;
              }),
            breakEndTime: Yup.string()
            .when('breakStartTime', {
                is: (val) => !!val, 
                then: (schema) => schema.required('Break end time is required if break start time is entered'),
                otherwise: (schema) => schema
              })
              .test('break-end-after-start', 'Break end time must be after start time', function (value) {
                if (!this.parent.breakStartTime || !value) return true;
                return value > this.parent.breakStartTime;
              })
              .test('break-end-validation', 'Break end time must be within valid working hours', function (value) {
                if (!value || !this.options.from[1].value.checked) return true;
                const day = this.options.from[1].value;
                const parent = this.options.context; // Access parent form values
                // 1. First try to validate against this row's working hours
                const currentRowWorkingHours = day.workingHours.filter(wh =>
                  wh.startTime && wh.endTime && wh.startTime !== '00:00' && wh.endTime !== '00:00'
                );
                // Check against current row's working hours if any exist
                if (currentRowWorkingHours.length > 0) {
                  return currentRowWorkingHours.some(wh =>
                    value >= wh.startTime && value <= wh.endTime
                  );
                }
                // 2. If no valid working hours in current row, look at first working hours in schedule
                if (parent && parent.schedule) {
                  const firstValidWorkingHours = parent.schedule
                    .flatMap(day => day.workingHours)
                    .find(wh => wh.startTime && wh.endTime && wh.startTime !== '00:00' && wh.endTime !== '00:00');
                  if (firstValidWorkingHours) {
                    return value >= firstValidWorkingHours.startTime && value <= firstValidWorkingHours.endTime;
                  }
                }
                // 3. If no reference working hours found at all, skip validation
                return true;
              })
              .test('break-time-overlap', 'Break time cannot overlap with another break', function (value) {
                if (!value || !this.parent.breakStartTime) return true;
                const breakTimings = this.options.from[1].value.breakTimings;
                if (!breakTimings || breakTimings.length <= 1) return true;
                // Get the index of the current break timing
                const currentBreakIndex = breakTimings.findIndex(
                  bt => bt.breakStartTime === this.parent.breakStartTime && bt.breakEndTime === value
                );
                // Check for overlap with other breaks
                return !breakTimings.some((bt, index) => {
                  if (index === currentBreakIndex || !bt.breakStartTime || !bt.breakEndTime) return false;
                  return (
                    (this.parent.breakStartTime >= bt.breakStartTime && this.parent.breakStartTime < bt.breakEndTime) ||
                    (value > bt.breakStartTime && value <= bt.breakEndTime) ||
                    (this.parent.breakStartTime <= bt.breakStartTime && value >= bt.breakEndTime)
                  );
                });
              })
          })
        )
      })
    )
  });



  const handleSubmit = async (values, { setSubmitting }) => {
    if (!doctorDetails) {
      toast.error('Doctor details not found. Please go back and try again.');
      return;
    }

    setLoading(true);
    try {
      const shifts = values.schedule
        .filter(day => day.checked)
        .flatMap(day => {
          const shiftsForDay = [];

          // Process all working hours for this day
          day.workingHours.forEach((workingHour, whIndex) => {
            if (!workingHour.startTime || !workingHour.endTime) {
              return; // Skip incomplete working hours
            }

            // Create the main shift with working hours
            const mainShift = {
              day: day.day,
              start_time: `${workingHour.startTime}:00`,
              end_time: `${workingHour.endTime}:00`,
              fee: parseInt(workingHour.fee) || parseInt(doctorDetails.consultationFees || 0)
            };

            // Filter break timings that fall within this specific working hour
            const validBreakTimings = day.breakTimings.filter(breakTiming =>
              breakTiming.breakStartTime &&
              breakTiming.breakEndTime &&
              breakTiming.breakStartTime >= workingHour.startTime &&
              breakTiming.breakStartTime <= workingHour.endTime &&
              breakTiming.breakEndTime >= workingHour.startTime &&
              breakTiming.breakEndTime <= workingHour.endTime
            );

            if (validBreakTimings.length === 0) {
              // No break timings for this working hour, just add the main shift
              shiftsForDay.push(mainShift);
            } else {
              // Add the main shift with the first break timing
              shiftsForDay.push({
                ...mainShift,
                break_start_time: `${validBreakTimings[0].breakStartTime}:00`,
                break_end_time: `${validBreakTimings[0].breakEndTime}:00`
              });

              // Add additional shifts for remaining break timings (with empty working hours)
              for (let i = 1; i < validBreakTimings.length; i++) {
                shiftsForDay.push({
                  day: day.day,
                  start_time: "00:00:00",
                  end_time: "00:00:00",
                  fee: parseInt(workingHour.fee) || parseInt(doctorDetails.consultationFees || 0),
                  break_start_time: `${validBreakTimings[i].breakStartTime}:00`,
                  break_end_time: `${validBreakTimings[i].breakEndTime}:00`
                });
              }
            }
          });

          return shiftsForDay;
        });

      // Format dates properly
      const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toISOString().split('T')[0];
      };

      const data = {
        role: "5",
        first_name: doctorDetails.doctorName?.split(' ')[0] || '',
        middle_name: "",
        last_name: doctorDetails.doctorName?.split(' ').slice(1).join(' ') || '',
        email: doctorDetails.emailAddress,
        phone_number: doctorDetails.mobileNumber,
        gender: doctorDetails.gender === "male" ? 1 : 2,
        country: doctorDetails.country || 1,
        state: doctorDetails.state || 1,
        city: doctorDetails.city || 1,
        address: "",
        is_active: 1,
        vendor_id: localStorage.getItem('vendorId'),
        specilisation: doctorDetails.specialization || '',
        practice_start: formatDate(doctorDetails.experienceStartDate),
        fee: parseInt(doctorDetails.consultationFees) || 0,
        appointment_duration: parseInt(values.appointmentDuration) || 15,
        no_of_slots: parseInt(values.numberOfSlots) || 10,
        created_by: parseInt(localStorage.getItem('userId')) || '',
        education: doctorDetails.education_id || '',
        shifts: shifts,
        latitude: 0,
        longitude: 0,
        ...(doctorId && { user_id: doctorId }),
        profile_image: doctorDetails.profileImage || null,
        is_login_eligible: doctorDetails.requiredLogin === "Yes" ? 1 : 0,
        unique_id: doctorDetails.uniqueId || '',
        dob: formatDate(doctorDetails.dateOfBirth),
        about_user: doctorDetails.about || '',
        ...(doctorId && { id: doctorId })
      };

      const endpoint = doctorId ? 'edit_availability' : 'service_providers_register';
      const res = await apicall.post(data, endpoint);

      if (res && (res.status === 200 || (res.message && res.message.includes('successfully')))) {
        const successMessage = doctorId ? 'Data Updated Successfully' : 'Doctor added successfully';

        // Clear session storage only after successful submission
        sessionStorage.removeItem('doctorDetails');

        toast.success(successMessage, {
          onClose: () => {
            navigate(userRole === '3' ? '/doctors' : '/users');
          },
          autoClose: 1500
        });
        return;
      }

      throw new Error(res?.message || (doctorId ? 'Failed to update availability' : 'Failed to add doctor'));

    } catch (e) {
      console.error('Error in handleSubmit:', e);
      if (!e.message.includes('successfully')) {
        toast.error(e.message.replace('Error:', ''));
      }
    } finally {
      setLoading(false);
      setSubmitting(false);
    }
  };

  // if (!initialData) {
  //   return <div>Loading...</div>;
  // }

  return (
    <div className={showPadding ? "px-0" : " "}>
      {showBackButton && (
        <div className="d-flex align-items-center mb-3 pt-3">
          <Button
            variant="link"
            className="text-dark text-decoration-none p-0 d-flex align-items-center"
            onClick={handleNavigation}
            style={{ fontSize: '14px' }}
          >
            <MdArrowBack size={20} /> BACK
          </Button>
        </div>
      )}

      <div className="bg-white rounded p-4">
        <h5 className="mb-2 fs-6 fw-semibold">
          {doctorId ? 'Edit your availability' : 'Set your availability'}
        </h5>
        <p className="mb-4" style={{ fontSize: '14px', color: '#6C757D' }}>
          {feeRange.working_hours_start && feeRange.working_hours_end &&
            `Customize your availability or use the default setting of Monday - Friday, ${feeRange.working_hours_start.substring(0, 5)} - ${feeRange.working_hours_end.substring(0, 5)} by selecting below`
          }
        </p>
        <div className="divide-border mb-4 mt-3" />

        <Formik
          initialValues={initialData}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            isSubmitting
          }) => (
            <Form onSubmit={handleSubmit}>
              <Row className="mb-4">
                <Col md={3}>
                  <Form.Group style={{ maxWidth: '200px' }}>
                    <Form.Label >
                      Appointment Duration
                    </Form.Label>
                    <Form.Select
                      name="appointmentDuration"
                      value={values.appointmentDuration}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      isInvalid={touched.appointmentDuration && errors.appointmentDuration}
                      className='form-text'
                    >
                      <option value="15">15 min</option>
                      <option value="30">30 min</option>
                      <option value="45">45 min</option>
                      <option value="60">60 min</option>
                    </Form.Select>
                    {touched.appointmentDuration && errors.appointmentDuration && (
                      <Form.Control.Feedback type="invalid">{errors.appointmentDuration}</Form.Control.Feedback>
                    )}
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group style={{ maxWidth: '200px' }}>
                    <Form.Label>
                      Number of slots
                    </Form.Label>
                    <Form.Select
                      name="numberOfSlots"
                      value={values.numberOfSlots}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      isInvalid={touched.numberOfSlots && errors.numberOfSlots}
                      className='form-text '

                    >
                      {[...Array(10)].map((_, i) => (
                        <option key={i + 1} value={i + 1}>
                          {i + 1}
                        </option>
                      ))}
                    </Form.Select>
                    {touched.numberOfSlots && errors.numberOfSlots && (
                      <Form.Control.Feedback type="invalid">{errors.numberOfSlots}</Form.Control.Feedback>
                    )}
                  </Form.Group>
                </Col>
                <Col className="d-flex justify-content-end align-items-end me-5">
                  <div
                    onClick={() => {
                      // Find the first checked day
                      const firstCheckedIndex = values.schedule.findIndex(day => day.checked);
                      if (firstCheckedIndex === -1) return; // No checked day, do nothing

                      values.schedule.forEach((_, idx) => {
                        if (idx !== firstCheckedIndex) {
                          // Copy working hours
                          setFieldValue(
                            `schedule.${idx}.workingHours`,
                            values.schedule[firstCheckedIndex].workingHours.map(wh => ({ ...wh }))
                          );
                          // Copy break timings
                          setFieldValue(
                            `schedule.${idx}.breakTimings`,
                            values.schedule[firstCheckedIndex].breakTimings.map(bt => ({ ...bt }))
                          );
                          // Copy checked status
                          setFieldValue(`schedule.${idx}.checked`, values.schedule[firstCheckedIndex].checked);
                        }
                      });
                    }}
                    className="apply-to-all custom-btn btn-larges">
                    Apply to All Weeks
                  </div>
                </Col>
              </Row>

              <div className="divide-border mb-4 mt-n2" />
              <div className="mb-3">
                <Row className="mb-2 align-items-center" style={{ fontWeight: 600, fontSize: 14 }}>
                  <Col md={2}>Days</Col>
                  <Col md={4} className="text-dark mb-2">
                    Working Hours
                    {feeRange.working_hours_start && feeRange.working_hours_end && (
                      <span className="text-muted" style={{ fontSize: '12px', fontWeight: 'normal' }}>
                        ({feeRange.working_hours_start.substring(0, 5)} - {feeRange.working_hours_end.substring(0, 5)})
                      </span>
                    )}
                  </Col>
                  <Col md={2} className="text-dark mb-2">Fee
                    <span className="text-muted" style={{ fontSize: '12px', fontWeight: 'normal' }}>
                      (Range : {feeRange.fee_from} - {feeRange.fee_to} AED)</span>
                  </Col>
                  <Col md={4}>Break Timing <span className="text-muted">(Optional)</span></Col>
                </Row>

                {values.schedule.map((day, dayIndex) => (
                  <React.Fragment key={day.day}>
                    <Row className="mb-3">
                      <Col md={2}>
                        <Form.Check
                          type="checkbox"
                          id={`schedule.${dayIndex}.checked`}
                          name={`schedule.${dayIndex}.checked`}
                          label={['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'][dayIndex]}
                          checked={values.schedule[dayIndex].checked}
                          onChange={(e) => {
                            const isChecked = e.target.checked;
                            setFieldValue(`schedule.${dayIndex}.checked`, isChecked);
                            if (isChecked) {
                              // When checking, initialize with default values if empty
                              if (day.workingHours.length === 0 ||
                                (!day.workingHours[0].startTime && !day.workingHours[0].endTime)) {
                                setFieldValue(`schedule.${dayIndex}.workingHours`, [{
                                  startTime: feeRange.working_hours_start?.substring(0, 5) || '',
                                  endTime: feeRange.working_hours_end?.substring(0, 5) || '',
                                  fee: ''
                                }]);
                                setFieldValue(`schedule.${dayIndex}.breakTimings`, [{
                                  breakStartTime: '',
                                  breakEndTime: ''
                                }]);
                              }
                            } else {
                              // When unchecking, clear all rows
                              setFieldValue(`schedule.${dayIndex}.workingHours`, [{
                                startTime: '',
                                endTime: '',
                                fee: ''
                              }]);
                              setFieldValue(`schedule.${dayIndex}.breakTimings`, [{
                                breakStartTime: '',
                                breakEndTime: ''
                              }]);
                            }
                          }}
                          style={{ fontSize: '14px' }}
                          className="custom-checkbox"
                        />
                      </Col>
                      <Col md={4}>
                        {day.workingHours.map((wh, whIdx) => (
                          <Row key={whIdx} className="align-items-center mb-2">
                            <Col xs={5}>
                              <Form.Control
                                type="time"
                                name={`schedule.${dayIndex}.workingHours.${whIdx}.startTime`}
                                value={wh.startTime}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                disabled={!day.checked}
                                isInvalid={
                                  touched.schedule?.[dayIndex]?.workingHours?.[whIdx]?.startTime &&
                                  errors.schedule?.[dayIndex]?.workingHours?.[whIdx]?.startTime
                                }
                                className='form-text'
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.schedule?.[dayIndex]?.workingHours?.[whIdx]?.startTime}
                              </Form.Control.Feedback>
                            </Col>
                            <Col xs={5}>
                              <Form.Control
                                type="time"
                                name={`schedule.${dayIndex}.workingHours.${whIdx}.endTime`}
                                value={wh.endTime}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                disabled={!day.checked}
                                isInvalid={
                                  touched.schedule?.[dayIndex]?.workingHours?.[whIdx]?.endTime &&
                                  errors.schedule?.[dayIndex]?.workingHours?.[whIdx]?.endTime
                                }
                                className='form-text'
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.schedule?.[dayIndex]?.workingHours?.[whIdx]?.endTime}
                              </Form.Control.Feedback>
                            </Col>
                            <Col xs={2} className="d-flex justify-content-center">
                              {day.workingHours.length > 1 && (
                                <button
                                  type="button"
                                  onClick={() => {
                                    // Remove only the working hours row, keep break timings independent
                                    const newWH = day.workingHours.filter((_, idx) => idx !== whIdx);
                                    setFieldValue(`schedule.${dayIndex}.workingHours`, newWH);
                                  }}
                                  className="btn p-0 border-0 bg-transparent d-flex align-items-center justify-content-center"

                                  aria-label="Remove row"
                                >
                                  <FiMinusCircle size={24} />
                                </button>
                              )}
                            </Col>
                          </Row>
                        ))}
                        {day.checked && (
                          <Button
                            variant="light"
                            size="sm"
                            onClick={() => {
                              setFieldValue(`schedule.${dayIndex}.workingHours`, [
                                ...day.workingHours,
                                {
                                  startTime: '',
                                  endTime: '',
                                  fee: ''
                                }
                              ]);
                              // Don't automatically add break timings - let users add them separately
                            }}
                            className="add-row-btn">
                            Add Row
                          </Button>
                        )}
                      </Col>
                      <Col md={2}>
                        {day.workingHours.map((wh, whIdx) => (
                          <Row key={whIdx} className="align-items-center mb-2">
                            <Col xs={12}>
                              <Form.Control
                                type="number"
                                name={`schedule.${dayIndex}.workingHours.${whIdx}.fee`}
                                value={wh.fee}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                placeholder="Fee"
                                disabled={!day.checked}
                                isInvalid={
                                  touched.schedule?.[dayIndex]?.workingHours?.[whIdx]?.fee &&
                                  errors.schedule?.[dayIndex]?.workingHours?.[whIdx]?.fee
                                }
                                className='form-text'
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.schedule?.[dayIndex]?.workingHours?.[whIdx]?.fee}
                              </Form.Control.Feedback>
                            </Col>
                          </Row>
                        ))}
                      </Col>
                      <Col md={4}>
                        {day.breakTimings.map((br, brIdx) => (
                          <Row key={brIdx} className="align-items-center mb-2">
                            <Col xs={5}>
                              <Form.Control
                                type="time"
                                name={`schedule.${dayIndex}.breakTimings.${brIdx}.breakStartTime`}
                                value={br.breakStartTime}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                disabled={!day.checked}
                                isInvalid={
                                  touched.schedule?.[dayIndex]?.breakTimings?.[brIdx]?.breakStartTime &&
                                  errors.schedule?.[dayIndex]?.breakTimings?.[brIdx]?.breakStartTime
                                }
                                className='form-text'
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.schedule?.[dayIndex]?.breakTimings?.[brIdx]?.breakStartTime}
                              </Form.Control.Feedback>
                            </Col>
                            <Col xs={5}>
                              <Form.Control
                                type="time"
                                name={`schedule.${dayIndex}.breakTimings.${brIdx}.breakEndTime`}
                                value={br.breakEndTime}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                disabled={!day.checked}
                                isInvalid={
                                  touched.schedule?.[dayIndex]?.breakTimings?.[brIdx]?.breakEndTime &&
                                  errors.schedule?.[dayIndex]?.breakTimings?.[brIdx]?.breakEndTime
                                }
                                className='form-text'
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.schedule?.[dayIndex]?.breakTimings?.[brIdx]?.breakEndTime}
                              </Form.Control.Feedback>
                            </Col>
                            <Col xs={2} className="d-flex justify-content-center">
                              {day.breakTimings.length > 1 && (
                                <button
                                  type="button"
                                  onClick={() => {
                                    const newBreaks = day.breakTimings.filter((_, idx) => idx !== brIdx);
                                    setFieldValue(`schedule.${dayIndex}.breakTimings`, newBreaks);
                                  }}
                                  className="btn p-0 border-0 bg-transparent d-flex align-items-center justify-content-center"

                                  aria-label="Remove break"
                                >
                                  <FiMinusCircle size={24} />
                                </button>
                              )}
                            </Col>
                          </Row>
                        ))}
                        {day.checked && (
                          <Button
                            variant="light"
                            size="sm"
                            onClick={() => {
                              setFieldValue(`schedule.${dayIndex}.breakTimings`, [
                                ...day.breakTimings,
                                { breakStartTime: '', breakEndTime: '' }
                              ]);
                            }}
                            className="add-row-btn">
                            Add Row
                          </Button>
                        )}
                      </Col>
                    </Row>
                  </React.Fragment>
                ))}
              </div>

              <div className="d-flex bg-white mt-2 p-2 justify-content-start gap-4">
                <Button
                  variant="light"
                  onClick={handleNavigation}
                  className="custom-btn btn-large"
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  variant="danger"
                  disabled={isSubmitting || loading}
                  className="custom-btn btn-large"
                >
                  {loading ? 'Loading...' : doctorId ? 'Update' : 'Submit'}
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default DoctorAvailability;